import React         from 'react';
import DrawerContext from '@widesk-ui/contexts/DrawerContext';

export default function useDrawer() {
	return React.useContext(DrawerContext);
}
